import React, { Component } from 'react';
import { appImgAlt, domainUrl } from '../config/Config';
import { getUserData, setUserData, clearUserData, reactLoader, message, getTokenData, parseJwt } from '../helpers/Common';
import { UserId, Username } from '../helpers/User';
import Footer from '../partials/Footer';

// Assign $ value to use jquery
const $ = window.$;

export default class TeleCall extends Component {
	constructor(props) {
		super(props);
		this.state = {
			date: getUserData("appFullDate", true),
			appImgAlt: appImgAlt,
			userName: Username(),
			teleCallBooked: false
		};
	}
	checkTelecallStatus() {
		reactLoader("show", "Please wait...");
		fetch(domainUrl + "user/telecall/status", {
			method: "POST",
			headers: {
				'Accept': 'application/json',
				'Content-Type': 'application/json',
				'Authorization': 'Bearer ' + getTokenData()
			},
			body: JSON.stringify({
				user_id: UserId()
			})
		}).then((response) => response.json()).then((responseJson) => {
			reactLoader("hide");
			if (responseJson.status === 0) {
				message(responseJson.message, responseJson.errors, "error");
			} else if (responseJson.callBooked) {
				this.setBackToLoginWithDelay();
				this.setState({
					teleCallBooked: true,
					scheduleDate: responseJson.scheduleDate,
					startTime: responseJson.startTime,
					endTime: responseJson.endTime
				});
			}
		});
	}
	setBackToLoginWithDelay(delayTime = 15000) {
		clearUserData();
		setTimeout(function () {
			this.props.router.push("login");
		}.bind(this), delayTime);
	}
	scheduleTeleCall() {
		let scheduleDate = this.refs.scheduleDate.value;
		let startTime = this.refs.startHR.value + ":" + this.refs.startMin.value;
		let endTime = this.refs.endHR.value + ":" + this.refs.endMin.value;
		reactLoader("show", "Please wait...");
		fetch(domainUrl + "user/telecall/schedule", {
			method: "POST",
			headers: {
				'Accept': 'application/json',
				'Content-Type': 'application/json',
				'Authorization': 'Bearer ' + getTokenData()
			},
			body: JSON.stringify({
				user_id: UserId(),
				schedule_date: scheduleDate,
				start_time: startTime,
				end_time: endTime
			})
		}).then((response) => response.json()).then((responseJson) => {
			if (responseJson.status === 0) {
				reactLoader("hide");
				message(responseJson.message, responseJson.errors, "error");
			} else {
				this.setState({
					teleCallBooked: true,
					scheduleDate: responseJson.scheduleDate,
					startTime: responseJson.startTime,
					endTime: responseJson.endTime
				});
				let userData = parseJwt(getTokenData());
				if (userData.beforeRoutes.length > 1) {
					userData.beforeRoutes.splice(0, 1);
					setUserData("beforeRoutes", userData.beforeRoutes, true);
					setTimeout(() => {
						reactLoader("hide");
						this.props.router.push(userData.beforeRoutes[0].url);
					}, 1200);
				} else {
					reactLoader("hide");
					this.setBackToLoginWithDelay();
				}
			}
		});
	}
	componentWillMount() {
		this.checkTelecallStatus();
	}
	componentDidMount() {
		document.body.className = "inner";
		$("#scheduleDate").datepicker({
			dateFormat: 'yy-mm-dd',
			changeMonth: true,
			yearRange: "-10:+0",
			changeYear: true
		}).val();
	}
	render() {
		return (<div className="row">
			<div id="reg_container">
				<div id="reg_header">
					<header>
						<div className="logo"><img src={process.env.PUBLIC_URL + '/images/logo.png'} alt="" title={this.state.appImgAlt} border="0" /></div>
						<div className="top-links reg-page"><img src={process.env.PUBLIC_URL + '/images/calendar_icon.png'} alt="" title="" border="0" /><span>{this.state.date}</span></div>
					</header>
					<section className="maincontent">
						<section className="content">
							<h1>Register for Tele-induction</h1>
							<div className="teleinduc grey-lite">
								Hi <span className="greentxt">{this.state.userName}</span>,
						            {!this.state.teleCallBooked &&
									<div className="nonusere-inner">
										You are logging after more than a month. For inducting you back into the program, your E Coach would like to have a telecall with you.<br />
										<div style={{ marginTop: "10px" }}>In the space below, please choose your preferred time for this tele-induction.</div>
										<div style={{ marginTop: "10px" }}>Thanks.</div>
										<form action="#" method="post" className="FrmSchedule">
											<table cellpadding="0" cellspacing="0" border="0" width="100%" className="tele-table">
												<tr>
													<td><b>Date </b></td>
													<td>
														<input type="text" ref="scheduleDate" id="scheduleDate" className="ScheduleDate" readonly />
													</td>
												</tr>
												<tr>
													<td><b>Time (IST)</b></td>
													<td>
														<select ref="startHR">
															<option value="00">00</option>
															<option value="01">01</option>
															<option value="02">02</option>
															<option value="03">03</option>
															<option value="04">04</option>
															<option value="05">05</option>
															<option value="06">06</option>
															<option value="07">07</option>
															<option value="08">08</option>
															<option value="09">09</option>
															<option value="10">10</option>
															<option value="11">11</option>
															<option value="12">12</option>
															<option value="13">13</option>
															<option value="14">14</option>
															<option value="15">15</option>
															<option value="16">16</option>
															<option value="17">17</option>
															<option value="18">18</option>
															<option value="19">19</option>
															<option value="20">20</option>
															<option value="21">21</option>
															<option value="22">22</option>
															<option value="23">23</option>
														</select>
														<span className="smaltxt">hrs</span> &nbsp;
						                                <select ref="startMin">
															<option value="00">00</option>
															<option value="15">15</option>
															<option value="30">30</option>
															<option value="45">45</option>
														</select>
														<span className="smaltxt">mins  &nbsp;&nbsp; <b>To</b> &nbsp; </span>
														<select ref="endHR">
															<option value="00">00</option>
															<option value="01">01</option>
															<option value="02">02</option>
															<option value="03">03</option>
															<option value="04">04</option>
															<option value="05">05</option>
															<option value="06">06</option>
															<option value="07">07</option>
															<option value="08">08</option>
															<option value="09">09</option>
															<option value="10">10</option>
															<option value="11">11</option>
															<option value="12">12</option>
															<option value="13">13</option>
															<option value="14">14</option>
															<option value="15">15</option>
															<option value="16">16</option>
															<option value="17">17</option>
															<option value="18">18</option>
															<option value="19">19</option>
															<option value="20">20</option>
															<option value="21">21</option>
															<option value="22">22</option>
															<option value="23">23</option>
														</select>
														<span className="smaltxt">hrs</span> &nbsp;
						                                <select ref="endMin">
															<option value="00">00</option>
															<option value="15">15</option>
															<option value="30">30</option>
															<option value="45">45</option>
														</select>
														<span className="smaltxt">mins</span>
													</td>
												</tr>
												<tr>
													<td>&nbsp;</td>
													<td>&nbsp;</td>
												</tr>
												<tr>
													<td>&nbsp;</td>
													<td colspan="2">
														<input type="button" value="Schedule" title="Schedule" onClick={() => this.scheduleTeleCall()} />
													</td>
												</tr>
											</table>
										</form>
									</div>
								}
								{this.state.teleCallBooked &&
									<div style={{ marginTop: "10px" }}>
										You have scheduled for the tele-induction on <span class="greentxt">{this.state.scheduleDate}</span> from <span class="greentxt">{this.state.startTime}</span> to <span class="greentxt">{this.state.endTime}</span> IST.
										<div style={{ marginTop: "10px" }}>
											Your E Coach shall call you for doing your tele-induction, after which you will be able to proceed with the rest of the Learning Rooms.
										</div>
									</div>
								}
							</div>
						</section>
					</section>
					<Footer />
				</div>
			</div>
		</div>);
	}
}



// WEBPACK FOOTER //
// ./src/pages/TeleCall.js